import styled from "styled-components/macro";
import React from "react";
import { Tooltip } from "antd";
import format from "date-fns/format";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 2px;
`;

const Inner = styled.div`
  padding: 16px;
  background: #f4f4f4;
  border-radius: 8px;
  text-align: center;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;
const TextTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;

const Text = styled.div``;

export const SystemMessage: React.FC<{
  title?: React.ReactNode;
  content?: React.ReactNode;
  date: Date;
}> = React.memo(({ date, title, content }) => {
  return (
    <Root>
      <Tooltip
        placement={"right"}
        mouseEnterDelay={0}
        mouseLeaveDelay={0}
        destroyTooltipOnHide={true}
        title={
          <div>
            <div>{format(date, "HH:mm")}</div>
          </div>
        }
      >
        <Inner>
          {title ? <TextTitle>{title}</TextTitle> : null}
          {content ? <Text>{content}</Text> : null}
        </Inner>
      </Tooltip>
    </Root>
  );
});
